import {ReactNode} from 'react';
import {useGuestCreation} from 'hooks/auth/useGuestCreation';
import {useOnboardingStore} from 'pages/Auth/store/useOnboardingStore';
import {GuestCreationContext} from './GuestCreationContext';

type GuestCreationProviderProps = {
  children: ReactNode;
};

export const GuestCreationProvider = ({children}: GuestCreationProviderProps) => {
  const {participants, guestsData} = useOnboardingStore();

  const guestCreationValue = useGuestCreation({
    participants,
    guestsData,
  });

  return (
    <GuestCreationContext.Provider value={guestCreationValue}>
      {children}
    </GuestCreationContext.Provider>
  );
};
